import { applyTheme } from 'Frontend/generated/theme'
import { html, LitElement, css } from 'lit'
import { customElement } from "lit/decorators.js"

@customElement("page-header")
class PageHeader extends LitElement {
    render() {
        return html`
            <div id="container">
                <div id="left-side">
                    <slot name="left-side"></slot>
                </div>
                <div id="right-side">
                    <slot name="right-side"></slot>
                </div>
            </div>
        `
    }

    connectedCallback(): void {
        super.connectedCallback()
        applyTheme(this.renderRoot)
    }

    static get styles() {
        return [
            css`
                @import url('https://fonts.googleapis.com/css2?family=Quicksand');

                :host {
                    --primary-color: var(--cdui-primary-color, #056e8e);

                    width: 100%;
                }

                #container {
                    height: 40px;
                    background: white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 24px;
                    border-radius: 20px;
                    font-family: 'Quicksand', sans-serif;
                    color: var(--primary-color);
                    border: 2px solid var(--primary-color);
                    font-size: 24px;
                }
            `
        ]
    }
}